import { render } from "./TicketPaymentFail.vue?vue&type=template&id=11bbb1ba&scoped=true"
import script from "./TicketPaymentFail.vue?vue&type=script&lang=js"
export * from "./TicketPaymentFail.vue?vue&type=script&lang=js"

import "./TicketPaymentFail.vue?vue&type=style&index=0&id=11bbb1ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bbb1ba"]])

export default __exports__